import {Button} from '@/components/ui/button/Button'
import {ComboboxInput} from '@/components/ui/combobox-atoms/ComboboxAtoms'
import {SelectComboboxList} from '@/components/ui/select-atoms/SelectAtoms'
import {makeSelectPopoverBaseStyle} from '@/components/ui/select-atoms/style'
import {Popover} from '@ariakit/react'
import styled, {css} from 'styled-components'

export const StyledUsersMultiSelectOverlay = styled.div(
    ({theme: {zIndex}}) => css`
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: transparent;
        z-index: ${zIndex.dropdown + 1};
        pointer-events: auto;
    `
)

export const StyledUsersMultiSelectPopover = styled(Popover)(
    ({theme, theme: {zIndex}}) => css`
        ${makeSelectPopoverBaseStyle(theme)};
        width: 280px;
        z-index: ${zIndex.dropdown + 2};
    `
)

export const StyledUsersMultiSelectPopoverInput = styled(ComboboxInput)(
    ({theme: {spacing}}) => css`
        margin: ${spacing}px 0;
    `
)

export const StyledUsersMultiSelectComboboxList = styled(SelectComboboxList)(
    ({theme: {spacing}}) => css`
        margin-top: ${spacing}px;
    `
)

export const StyledUsersMultiSelectPopoverOption = styled(Button)(
    ({theme: {spacing, palette}}) => css`
        width: 100%;
        padding: ${spacing * 1.5}px ${spacing * 2}px;
        border-radius: 6px;
        justify-content: flex-start;
        &:hover {
            background-color: ${palette.neutral[100]};
        }
    `
)
